import React, { Component } from 'react';
import { withRouter } from './withRouter.js';
import {Container, Jumbotron, Row, Col, Card, Button } from 'react-bootstrap';
import { FiExternalLink } from "react-icons/fi";
import zhongzheng from './img/Zhongzheng-Xu.png'
import taehyun from './img/Taehyun-Yang.png'
import fumeng from './img/FumengYang-2024-2-1.png'

class People extends Component { 



    render(){
        return(
            <>
            <h2  id='crew'> Teaching crew</h2>
            <Row className='people-card-row'>
              <Col xs={12} sm={12} md={3} lg={3}>
                <Card className='people-card'>
                  <Card.Img variant="top" src={fumeng} />
                  <Card.Body>
                    <Card.Title><a href="https://www.fmyang.com" target='_blank' className='normal-a'>Fumeng  (she/her) <FiExternalLink /></a></Card.Title>
                    <Card.Text>
                      Fumeng Yang<br/>
                      Instructor<br/>
                      Hours: M class to 4:15p<br/>
                      Classroom & IRB 5138
                      <p className='name-sound'>🗣️ <b>foo</b> + <b>mung</b> (rhymes with hung)</p>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <Card className='people-card'>
                  <Card.Img variant="top" src={zhongzheng} />
                  <Card.Body>
                    <Card.Title><a href="https://lebretou.github.io/" target='_blank' className='normal-a'>Zhongzheng (he/him) <FiExternalLink /></a></Card.Title>
                    <Card.Text>
                      Zhongzheng Xu<br/>
                      Teaching Assistant<br/>
                      Hours: Thu 2-3p<br/>
                      Zoom Link on Canvas
                      <p className='name-sound'>🗣️ <b>jong</b> (rhymes with gong) + <b>jung</b> (rhymes with hung)</p>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <Card className='people-card'>
                  <Card.Img variant="top" src={taehyun} />
                  <Card.Body>
                    <Card.Title><a href='https://taehyun.me/' target='_blank' className='normal-a'>Taehyun (he/him) <FiExternalLink /></a></Card.Title>
                    <Card.Text>
                      Taehyun Yang<br/>
                      Teaching Assistant<br/>
                      Hours: Thu 10-11a<br/>
                      Zoom Link on Canvas
                      <p className='name-sound'>🗣️ <b>tay</b> (rhymes with day) + <b>hyun</b> (rhymes with fun)</p>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
             </>
        )
    }
}



export default People;